import { render, staticRenderFns } from "./Swedbank.vue?vue&type=template&id=1fe70b18&"
import script from "./Swedbank.vue?vue&type=script&lang=js&"
export * from "./Swedbank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports